import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getChildComponents, MapTo, } from "@adobe/aem-react-editable-components";
import { DEPRECATED_Typography as Typography } from "@jti/ui";
import { withEditConfig } from "../../app-related/withAemAuthoring";
import { withAuthorPanelSwitch } from "./AbstractCoreContainerComponent";
import styles from "./Tabs.module.scss";
const TabsEditConfig = {
    emptyLabel: "Tabs",
    isEmpty: (props) => props.cqItemsOrder == null || props.cqItemsOrder.length === 0,
};
export const Tabs = (props) => {
    const [activeIndex, setActiveIndex] = useState(!!props.activeItem && props.activeItem.length > 0 && props.cqItemsOrder
        ? props.cqItemsOrder.indexOf(props.activeItem)
        : 0);
    useEffect(() => {
        const paramName = "activeTab";
        const params = new URLSearchParams(window.location.search);
        if (params.has(paramName)) {
            setActiveIndex(Number(params.get(paramName)));
        }
    }, []);
    useEffect(() => {
        if (props.activeIndexFromAuthorPanel !== undefined) {
            setActiveIndex(props.activeIndexFromAuthorPanel);
        }
    }, [props.activeIndexFromAuthorPanel]);
    const tabbedChildComponents = () => {
        const childComponents = getChildComponents({ ...props });
        if (props.isInEditor === true) {
            return (_jsx(_Fragment, { children: childComponents.map((item, index) => {
                    const isVisible = activeIndex === index;
                    const styles = { display: !isVisible ? "none" : "block" };
                    return (_jsx("div", { "data-cmp-hook-tabs": "tabpanel", className: `cmp-tabs__tabpanel${isVisible ? " cmp-tabs__tabpanel--active" : ""}`, style: styles, children: item }, item.key));
                }) }));
        }
        else {
            return childComponents[activeIndex];
        }
    };
    const handleTabNavClick = (index) => {
        if (activeIndex !== index) {
            setActiveIndex(index);
            const list = document.getElementById("tabList");
            if (list) {
                list.children[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
            }
        }
    };
    const tabNavigation = () => {
        const childComponents = [];
        if (!props.cqItems || !props.cqItemsOrder)
            return childComponents;
        return (_jsx("ol", { id: "tabList", role: "tablist", className: `cmp-tabs__tablist ${styles.tabList}`, "aria-label": props.accessibilityLabel, "aria-multiselectable": "false", children: props.cqItemsOrder.map((item, index) => {
                const tab = props.cqItems[item];
                const isActive = index === activeIndex;
                return (_jsx("li", { role: "tab", onClick: () => handleTabNavClick(index), className: `cmp-tabs__tab ${styles.tabItem} ${isActive ? `cmp-tabs__tab--active ${styles.tabItemActive}` : ""}`, "data-cmp-hook-tabs": "tab", children: 
                    // @ts-expect-error" this field does not exist on Model type from adobe lib
                    tab["panelTitle"] }, "tab-" + index));
            }) }));
    };
    return (_jsxs("div", { "data-cmp-is": "tabs", "data-testid": "tabs", className: "cmp-tabs", "data-panelcontainer": "tabs", id: props.id, children: [_jsx(Typography, { type: "h1", color: "black", className: styles.title, children: props.title }), !TabsEditConfig.isEmpty(props) && tabNavigation(), !TabsEditConfig.isEmpty(props) && (_jsx("div", { "data-testid": "tabContent", className: styles.childComponents, children: tabbedChildComponents() }))] }));
};
export default MapTo("loyalty/components/tabs")(withEditConfig(withAuthorPanelSwitch(Tabs), TabsEditConfig));
